'use strict';

module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};



//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/~/axios/lib/helpers/parseProtocol.js
// module id = 101
// module chunks = 0